import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { userPlaceholder } from 'images';
import styles from './UserAccountHeader.scss';
const cx = classnames.bind(styles);
const UserAccountHeader = memo(({ userFullName, joinedDate }) => (React.createElement("div", { className: cx('user-account-header'), "data-testid": "user-account-header" },
    React.createElement("div", { className: cx('user-account-header-avatar') },
        React.createElement("div", { className: cx('user-account-header-avatar-image') },
            React.createElement("img", { src: userPlaceholder, alt: "Avatar" }))),
    React.createElement("div", { className: cx('user-account-brief-info') },
        React.createElement("h1", { "data-testid": "user-account-name", className: cx('user-account-name') }, userFullName),
        !!joinedDate && (React.createElement("p", { "data-testid": "user-account-joined-date", className: cx('user-account-joined-date') }, `Joined on ${new Date(joinedDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        })}`))))));
export default UserAccountHeader;
